import { useQueryClient } from "@tanstack/react-query";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Hero } from "../sections/Hero";
import { SpecBand } from "../sections/SpecBand";
import { Marquee } from "../sections/Marquee";
import { Products } from "../sections/Products";
import { Sizes } from "../sections/Sizes";
import { Finishes } from "../sections/Finishes";
import { Gallery } from "../sections/Gallery";
import { QuoteForm } from "../sections/QuoteForm";
import { useSiteContent } from "../App";

const FALLBACK = {
  announcement: "MOQ 250 units · Dispatch from 3 weeks · Worldwide delivery",
  hero_kicker: "Bespoke cardboard tube packaging",
  hero_line1: "Custom printed",
  hero_line2: "cardboard tubes,",
  hero_line3: "made to order.",
  hero_sub: "Butt joint, telescopic and tin lid tubes in 12 standard diameters — printed in CMYK or matched to your Pantone, finished with hot foil and spot UV.",
  moq: 250,
  lead_time_weeks: 3,
  contact_email: "sales@tubeboxesdirect.com",
  sizes: [40, 48, 56, 61, 73, 80, 87, 100, 107, 117, 127, 147],
  products: [],
  finishes: [],
};

export default function LandingPage() {
  const { data } = useSiteContent();
  const queryClient = useQueryClient();
  const content = { ...FALLBACK, ...(data || {}) };
  const hasCatalog = content.products.length > 0 && content.finishes.length > 0;

  if (data && !hasCatalog) {
    queryClient.invalidateQueries({ queryKey: ["site-content"] });
  }

  return (
    <div data-testid="landing-page">
      <Header announcement={content.announcement} />
      <Hero content={content} />
      <SpecBand content={content} />
      <Marquee />
      {content.products.length > 0 && <Products products={content.products} />}
      <Sizes sizes={content.sizes} />
      {content.finishes.length > 0 && <Finishes finishes={content.finishes} />}
      {content.gallery?.length > 0 && <Gallery items={content.gallery} />}
      {hasCatalog && <QuoteForm content={content} />}
      <Marquee />
      <Footer email={content.contact_email} />
    </div>
  );
}
